package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.Serializable

@Serializable
data class WorkspaceRequest(
    val name: String,
    val workspaceType: String
)